import React, { useEffect, useState } from "react";
import "../../styles/institution/institutionBatch.scss";
import {
  createBatchInstitution,
  deleteBatchInstitution,
  getAllBatchInstitution,
  updateBatchInstitution,
} from "../../helper/apicalls/institution/institutionBatch";
import Cookies from "js-cookie";
import BatchCard from "../admin/batchCard";
import EmptyPage from "../common/emptyPage";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import BatchForm from "../admin/BatchForm";
// import SearchIcon from "@mui/icons-material/Search";
import DeleteConfirmPopUp from "../common/deleteConfirmPopUp";
import GlobalLoader from "../common/GlobalLoader";
// import { createInstitutionCourseBatch } from "../../helper/apicalls/institution";
import SuccessPopup from "../common/SuccessPopup";

const BatchInstitution = () => {
  const authToken = Cookies.get("institution_token");
  const role = Cookies.get("role");
  const navigate = useNavigate();
  const permissions = Cookies.get("permissions");
  let permissionsData = [];
  try {
    const parsed = permissions ? JSON.parse(permissions) : [];
    permissionsData = Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.error("Error parsing permissions:", e);
  }
  const hasBatchPermission = permissionsData?.find(
    (permission) => permission?.permission_type === "batches",
  );

  const { setHeaderName, setIsShowSearch } = useOutletContext();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const course_key = searchParams.get("course");
  const [batchList, setBatchList] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [currentBatch, setCurrentBatch] = useState(null);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const fetchBatchData = async () => {
    // console.log(course_key, "course_key");

    setLoader(true);
    try {
      const params = {};
      if (debouncedSearch.trim()) params.search = debouncedSearch.trim();
      const response = await getAllBatchInstitution(
        authToken,
        course_key,
        params,
      );
      console.log("Batch Data:", response);
      setBatchList(response?.data || []);
    } catch (err) {
      console.error("Failed to fetch batches:", err);
    } finally {
      setLoader(false);
    }
  };

  const handleCreateClick = () => {
    setCurrentBatch(null);
    setIsFormOpen(true);
  };

  const handleCardEdit = (data) => {
    if (!data) return;
    setCurrentBatch(data);
    setIsFormOpen(true);
  };

  const handleCardDelete = (batch) => {
    setDeleteTarget(batch);
    setIsConfirmDeleteOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setCurrentBatch(null);
  };

  const handleFormSubmit = async (data) => {
    setLoader(true);
    try {
      if (currentBatch) {
        const res = await updateBatchInstitution(
          authToken,
          data,
          currentBatch?.id,
        );
        console.log("Update Batch Response:", res);
        setSuccessOpen(true);
        setSuccessMsg(res?.message || "Batches update successfully");
        handleFormClose();
        await fetchBatchData();
      } else {
        const res = await createBatchInstitution(authToken, {
          ...data,
          course_key: course_key,
        });
        console.log("Create Batch Response:", res);
        setSuccessOpen(true);
        handleFormClose();
        setSuccessMsg(res?.message || "Batch added successfully");
        await fetchBatchData();
      }
    } catch (err) {
      console.error("Failed to submit batch:", err);
      handleFormClose();
    } finally {
      setLoader(false);
    }
  };
  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;
    setLoader(true);
    try {
      const res = await deleteBatchInstitution(authToken, deleteTarget?.id);
      setSuccessOpen(true);
      setIsConfirmDeleteOpen(false);
      setSuccessMsg(res?.message || "Batch deleted successfully");
      await fetchBatchData();
    } catch (err) {
      console.error("Failed to delete batch:", err);
    } finally {
      setLoader(false);

      setDeleteTarget(null);
    }
  };

  useEffect(() => {
    setHeaderName("Batches");
    setIsShowSearch && setIsShowSearch(false);
  }, []);

  useEffect(() => {
    fetchBatchData();
  }, [debouncedSearch]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchInput), 300);
    return () => clearTimeout(t);
  }, [searchInput]);

  return (
    <div className="institution-batch-container">
      {loader && <GlobalLoader visible={loader} text="Loading batches..." />}
      <div className="institution-batch-header">
        <h2 style={{ margin: 0 }}>Batches List</h2>

        {hasBatchPermission?.write && (
          <button
            className="institution-course-create-btn btn-interactive"
            onClick={handleCreateClick}
          >
            Create Batch
          </button>
        )}
      </div>
      {batchList?.length > 0 ? (
        <div className="institution-batch-grid">
          {batchList?.map((data, index) => {
            return (
              <BatchCard
                batch={data}
                index={index}
                key={index}
                onClick={() => {
                  if (role === "teacher") {
                    // In teacher homework flow, go to homework subjects
                    if (location.pathname.startsWith("/teacher/homework")) {
                      navigate(`/teacher/homework/course/${course_key}`);
                      return;
                    }
                    if (location.pathname.startsWith("/teacher/batches")) {
                      navigate(
                        `/teacher/batches/details?course=${course_key}&batch_id=${data?.id}`,
                        { state: { batchName: data?.name } }
                      );
                      return;
                    }
                    const secretKey = sessionStorage.getItem("secret_key");
                    const batchId = data?.id;

                    if (secretKey && batchId && course_key) {
                      const userFrontendUrl = process.env.REACT_APP_USER_FRONTEND_URL;
                      const url =
                        `${userFrontendUrl}/login?secret_token=${secretKey}` +
                        `&courseKey=${course_key}&batchid=${batchId}`;
                      window.open(url, "_blank");
                    }
                    return;
                  }

                  navigate(
                    `/institution/batches/details?course=${course_key}&batch_id=${data?.id}`,
                    { state: { batchName: data?.name } },
                  );
                }}
                hideActions={!hasBatchPermission?.write}
                onEditData={handleCardEdit}
                onDelete={handleCardDelete}
              />
            );
          })}
        </div>
      ) : (
        <EmptyPage content={"No batches Available"} />
      )}
      {isFormOpen && (
        <BatchForm
          isOpen={isFormOpen}
          onClose={handleFormClose}
          onSubmit={handleFormSubmit}
          initialData={currentBatch}
        />
      )}
      {isConfirmDeleteOpen && (
        <DeleteConfirmPopUp
          isConfirmDeleteOpen={isConfirmDeleteOpen}
          setIsConfirmDeleteOpen={setIsConfirmDeleteOpen}
          handleDelete={handleConfirmDelete}
          title="Delete batch"
          message="Are you sure you want to delete this batch? This action cannot be undone."
          confirmLabel="Delete"
          cancelLabel="Cancel"
        />
      )}
      {successOpen && (
        <SuccessPopup
          open={successOpen}
          onClose={() => setSuccessOpen(false)}
          message={successMsg}
        />
      )}
    </div>
  );
};

export default BatchInstitution;
